import { useEffect, useState } from "react";
import Ratingscale from "../components/Ratingscale";
import Slider from "../components/Slider";
import ReactDatePicker from "react-datepicker";
import API_BASE_URL from "../config";
import Fileuploader from "./Fileuploader";

export default function Surveyquestion(props) {
  const [multioptions, setMultioptions] = useState([]);

  useEffect(() => {
    const loadMultivalQues = async () => {
      const resMultiFields = await fetch(
        `${API_BASE_URL}GetAllMultiQuestionOptions.php/${props.Id}`
      );
      const resmf = await resMultiFields.json();
      setMultioptions(await resmf.data);
      console.log(resmf.data);
    };
    loadMultivalQues();
  }, [props.Id]);

  return (
    <div>
      {props.ControlType === "Text Box" && props.InputType === "Text" && (
        <input
          type="text"
          className="form-control"
          maxLength={props.MaxLength}
        />
      )}
      {props.ControlType === "Text Box" && props.InputType === "Numeric" && (
        <input
          type="number"
          className="form-control"
          min={props.MinRange}
          max={props.MaxRange}
        />
      )}
      {props.ControlType === "Dropdown" && (
        <select className="custom-select mr-sm-2">
          <option>Choose...</option>
          {multioptions?.map((opt, index) => (
            <option value={opt.ques_opt_val}>{opt.ques_opt_txt}</option>
          ))}
        </select>
      )}
      {props.ControlType === "Radio Button" && (
        <div className="col-md-6">
          {multioptions?.map((opt, index) => (
            <div className="row mx-3">
              <input
                name={"radio_" + props.Id}
                className="form-check-input"
                type="radio"
                value={opt.ques_opt_val}
              />
              <label className="form-check-label">{opt.ques_opt_txt}</label>
            </div>
          ))}
          <div>
            <a
              className="small mb-1"
              title="Reset"
              style={{ cursor: "pointer" }}
            >
              Reset
            </a>
          </div>
        </div>
      )}
      {props.ControlType === "Check Box" && (
        <div className="col-md-6">
          {multioptions?.map((opt, index) => (
            <div className="row mx-3 mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                value={opt.ques_opt_val}
              />
              <label className="form-check-label">{opt.ques_opt_txt}</label>
            </div>
          ))}
        </div>
      )}
      {props.ControlType === "Multiline Text" && (
        <textarea className="form-control"></textarea>
      )}
      {props.ControlType === "Rating Scale" && (
        <Ratingscale maxRating={props.scale_range} />
      )}
      {props.ControlType === "Slider" && (
        <Slider min={props.min_range} max={props.max_range} />
      )}
      {props.ControlType.toUpperCase() === "DATE" && (
        <div className="react-datepicker__input-container">
          <i
            title="Calendar"
            className="icon fas fa-calendar-alt"
            style={{ fontSize: 18 }}
          ></i>
          &nbsp;&nbsp;
          <ReactDatePicker
            id="date"
            className="form-control"
            showMonthDropdown
            showYearDropdown
          />
        </div>
      )}
      {props.ControlType.toUpperCase() === "FILE UPLOADER" && (
        <div>
          <Fileuploader id={props.id} />
        </div>
      )}
      {props.ControlType.toUpperCase() === "NEW SECTION" && (
        <div dangerouslySetInnerHTML={{ __html: props.Description }}></div>
      )}
    </div>
  );
}
